import React from 'react'
import './bookmark.css'

export const Bookmark = ({color}) => {
  return (
    <div className='bookmark' style={{borderLeft: `10px solid ${color ?? 'red'}`, borderRight: `10px solid ${color ?? 'red'}`}}></div>
  )
}
